const initialState = {
    filter_categories: [],
    filter_authors: []
}

export default initialState;